/**
 * DivBadgeLg — division badge for the school detail hero block.
 * Matches the style in detail-atoms.jsx DivBadgeLg.
 */
import React from 'react';

interface Props {
  children: React.ReactNode;
}

export function DivBadgeLg({ children }: Props) {
  return (
    <span className="inline-block px-2 py-0.5 text-[11px] font-bold tracking-wide bg-surface-sunken text-gray-700 rounded tabular-nums">
      {children}
    </span>
  );
}
